import {faStar,faHeart, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { faCommentDots} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Style from "./StoreHeader.module.css"
import { Link, useHistory } from "react-router-dom";
import { addsupplierTofavorite, removeSupplierTofavorite } from "../../Api/BarestServices";
import { succToast,errorToast } from "../../Toast/Toast";

const StoreHeader = (props) => {

  const [ gold , setGold]=useState(false)
  useEffect(()=>{
    if(props.data.favorite==="1"){
      setGold(true)
    }
  },[props.data])

  const favoriteHandler=()=>{
    let supplierId={
      id:props.data.id
    }
    if(!gold)
    {
      addsupplierTofavorite(supplierId,(res)=>{
        if(res.status===0){
          errorToast(res.message)
        }
        else{
          succToast(res.message)
          setGold(true)
        }
      })
    }
    else{
      removeSupplierTofavorite(supplierId,(res)=>{
        if(res.status===0){
          errorToast(res.message)
        }
        else{
          errorToast(res.message)
          setGold(false)
        }
      })
      
    }
  }
  let history = useHistory();
  return (
    <div className={Style.HeaderHolder}>
      <img src={`//cdn.barest.ir/supplier/cover/${props.data.cover}.jpg`} alt={props.data.name} />
      <div onClick={favoriteHandler} className={Style.favorite}>
        <FontAwesomeIcon icon={faHeart} className={gold ? Style.goldStar :Style.whiteStar } />
      </div>
      <div onClick={() => history.goBack()} className={Style.Back}>
        <FontAwesomeIcon  icon={faArrowRight} className={Style.backIcon}/>
      </div>
      <div className={Style.RestaurantInfo}>
        <div className={Style.NameHolder}>
          <h3>{props.data.name}</h3>
          <div className={Style.StoreRate}>
            <div className={Style.FixRate}>
              <div className={Style.RateHolder}>
                <div className={Style.grayStar}>
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                </div>
                <div className={Style.GoldStar} style={{ width: `${props.data.supplier_rate*20}%` }}>
                  <div className={Style.GoldStarHolder}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        <Link className={Style.AboutStore} to={{pathname:`/supplier/${props.data.id}/about/`,state:props.data}}><p>اطلاعات <span>{props.data.name} </span></p></Link>
        </div>
        <div className={Style.CommentDirection}>
          <div className={Style.CommentLogo} onClick={()=>{history.push(`/supplier/${props.data.id}/comments`,props.data.id)}}>
            <FontAwesomeIcon icon={faCommentDots} />
            <p>نظرات</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreHeader;
